import { Text, VFlow } from 'bold-ui'
import React from 'react'

export const UnificacaoBaseOrientacoesView = () => {
  return (
    <VFlow vSpacing={0}>
      <Text color='primary'>
        <strong>1</strong> - É necessário realizar o download do backup de ambas as bases antes de iniciar o processo de
        unificação de base;
      </Text>
      <Text color='primary'>
        <strong>2</strong> - É recomendado que o processo de unificação de base seja realizado apenas para o link da
        instalação central do município e fora do horário de expediente de trabalho;
      </Text>
      <Text color='primary'>
        <strong>3</strong> - É necessário que a versão do sistema da instalação local seja a mesma da instalação central
        do município;
      </Text>
      <Text color='primary'>
        <strong>4</strong> - A instalação central do município deve possuir o link de instalação com o serviço https{' '}
        <i>(ex.: https://linkdainstalacao.gov.br)</i>;
      </Text>
      <Text color='primary'>
        <strong>5</strong> - Atualize o CNES da instalação local e da instalação central do município para o mais
        recente;
      </Text>
      <Text color='primary'>
        <strong>6</strong> - Para realizar a solicitação de unificação, o administrador da instalação central do
        município deverá criar qualquer tipo de acesso na sua própria instalação para o responsável pela instalação
        local que enviará os dados. Ou seja, o solicitante também deverá ter um login na instalação central que receberá
        os dados;
      </Text>
      <Text color='primary'>
        <strong>7</strong> - Os perfis personalizados criados manualmente na instalação local não serão enviados para a
        instalação central do município. Nesse caso, serão atribuídos os perfis padrão de acordo com o CBO do
        profissional. Caso necessário, os perfis cadastrados manualmente precisarão ser recadastrados na instalação
        central do município <i>(ex.: perfil de administrador de banco de dados)</i>;
      </Text>
      <Text color='primary'>
        <strong>8</strong> - Ambas as instalações devem possuir as mesmas equipes e unidades de saúde. Caso haja
        divergência, o sistema apresentará uma lista contendo as informações faltantes e o administrador da instalação
        local deverá entrar em contato com o suporte;
      </Text>
      <Text color='primary'>
        <strong>9</strong> - O envio será de cidadãos que possuam prontuário ou vínculo com equipes profissionais
        cadastradas via PEC. As consultas agendadas dos cidadãos serão enviadas normalmente. Contudo, as agendas
        individuais dos profissionais não serão enviadas <i>(fechamento, dias e horários de trabalho)</i>. Será
        necessário recadastrá-las na instalação central do município.
      </Text>
    </VFlow>
  )
}
